import classNames from "classnames";
function Input_Textfield({
    onChange,
    hideError,
    error,
    name,
    type,
    placeholder,
    className,
    refProp,
    value,
    readonly,
    maxlength,
    min,
    max
}) {
    return (
        <>
            <input type={type} maxlength={maxlength} min={min} max={max} name={name} value={value} disabled={readonly} ref={refProp} placeholder={placeholder} onChange={onChange} className={classNames(className, {'input-error': error})}></input>
            { !hideError && error && (
                <span className="error-message">
                    {error}
                </span>
            )}
        </>
    );
};

export default Input_Textfield;